import { render, staticRenderFns } from "./UCoursesHome.vue?vue&type=template&id=45fdad6a&scoped=true&"
import script from "./UCoursesHome.vue?vue&type=script&lang=js&"
export * from "./UCoursesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fdad6a",
  null
  
)

export default component.exports